export enum AuthDialogs {
  SIGN_IN = 'SIGN_IN',
  SIGN_IN_TELEGRAM = 'SIGN_IN_TELEGRAM',
  SIGN_IN_FULFILLED = 'SIGN_IN_FULFILLED',
}
